import { cookieStorage } from "@/pinia/cookieStorage";
import useTimezone from "@/composables/useTimezone";

/**
 * Single source of truth for the auth/context headers attached to API requests.
 * Used by the shared axios instances and by callers that go around axios
 * (e.g. the fetch/oboe streaming path) so header changes stay in one place.
 */
export function buildAuthHeaders() {
    const headers = {};

    const auth = JSON.parse(cookieStorage.getItem("auth") || "{}");
    if (auth?.token) {
        headers.Authorization = `Bearer ${auth.token}`;
    }

    const { getClientTimezone } = useTimezone();
    headers["X-Client-Timezone"] = getClientTimezone();

    return headers;
}
